
import * as utils from '../../utils/schoolUtils'
import { Timestamp } from 'firebase/firestore'

export class Student {
  constructor({
    admissionNo,
    name,
    gender,
    dob,
    age = 0.0,
    contactNo,
    Class,
    sec,
    guardian,
    guardianRelation,
    guardianOccupation,
    guardianMobNo,
    fatherName,
    fatherMobNo,
    fatherOccupation,
    motherName,
    motherOccupation,
    motherMobNo,
    houseName,
    placeOfHouse,
    postOffice,
    taluk,
    pinCode,
    rationCard,
    physicallyChallenged = false,
    previousSchool,
    aadhaarNo,
    address,
    category,
    admissionDate,
    admissionClass = -2,
    nationality,
    caste,
    community,
    motherTongue,
    busNo,
    boardingPlace,
    siblings = [],
  } = {}) {
    this.admissionNo = admissionNo;
    this.name = name;
    this.gender = gender;
    this.dob = dob;
    this.age = age;
    this.contactNo = contactNo;
    this.Class = Class;
    this.sec = sec != null ? sec.toString().trim() : null;
    this.guardian = guardian;
    this.guardianRelation = guardianRelation;
    this.guardianOccupation = guardianOccupation;
    this.guardianMobNo = guardianMobNo;
    this.fatherName = fatherName;
    this.fatherMobNo = fatherMobNo;
    this.fatherOccupation = fatherOccupation;
    this.motherName = motherName;
    this.motherMobNo = motherMobNo;
    this.motherOccupation = motherOccupation;
    this.houseName = houseName;
    this.placeOfHouse = placeOfHouse;
    this.postOffice = postOffice;
    this.taluk = taluk;
    this.pinCode = pinCode;
    this.rationCard = rationCard;
    this.physicallyChallenged = physicallyChallenged;
    this.previousSchool = previousSchool;
    this.aadhaarNo = aadhaarNo;
    this.address = address;
    this.category = category;
    this.admissionDate = admissionDate;
    this.admissionClass = admissionClass;
    this.nationality = nationality;
    this.caste = caste;
    this.community = community;
    this.motherTongue = motherTongue;
    this.busNo = busNo;
    this.boardingPlace = boardingPlace;
    this.siblings = siblings;
  }

  static fromMap(data) {
    return new Student({
      admissionNo: data.admissionNo,
      name: data.name,
      gender: data.gender,
      dob: data.dob,
      age: data.age,
      contactNo: data.contactNo,
      Class: data.Class,
      sec: data.sec,
      guardian: data.guardian,
      guardianRelation: data.guardianRelation,
      guardianMobNo: data.guardianMobNo,
      guardianOccupation: data.guardianOccupation,
      fatherName: data.fatherName,
      fatherMobNo: data.fatherMobNo,
      fatherOccupation: data.fatherOccupation,
      motherName: data.motherName,
      motherMobNo: data.motherMobNo,
      motherOccupation: data.motherOccupation,
      houseName: data.houseName,
      placeOfHouse: data.placeOfHouse,
      taluk: data.taluk,
      postOffice: data.postOffice,
      pinCode: data.pinCode,
      rationCard: data.rationCard,
      physicallyChallenged: data.physicallyChallenged,
      previousSchool: data.previousSchool,
      aadhaarNo: data.aadhaarNo,
      address: data.address,
      category: data.category,
      admissionDate: data.admissionDate,
      admissionClass: data.admissionClass,
      nationality: data.nationality,
      caste: data.caste,
      community: data.community,
      motherTongue: data.motherTongue,
      busNo: data.busNo,
      boardingPlace: data.boardingPlace,
      siblings: data.siblings || [],
    });
  }

  toMap() {
    const map = {
      admissionNo: this.admissionNo,
      name: this.name,
      gender: this.gender,
      dob: this.dob,
      age: this.age,
      contactNo: this.contactNo,
      Class: this.Class,
      sec: this.sec,
      guardian: this.guardian,
      guardianRelation: this.guardianRelation,
      guardianMobNo: this.guardianMobNo,
      guardianOccupation: this.guardianOccupation,
      fatherName: this.fatherName,
      fatherMobNo: this.fatherMobNo,
      fatherOccupation: this.fatherOccupation,
      motherName: this.motherName,
      motherMobNo: this.motherMobNo,
      motherOccupation: this.motherOccupation,
      houseName: this.houseName,
      placeOfHouse: this.placeOfHouse,
      postOffice: this.postOffice,
      taluk: this.taluk,
      pinCode: this.pinCode,
      rationCard: this.rationCard,
      physicallyChallenged: this.physicallyChallenged,
      previousSchool: this.previousSchool,
      aadhaarNo: this.aadhaarNo,
      address: this.address,
      category: this.category,
      admissionDate: this.admissionDate,
      admissionClass: this.admissionClass,
      nationality: this.nationality,
      caste: this.caste,
      community: this.community,
      motherTongue: this.motherTongue,
      busNo: this.busNo,
      boardingPlace: this.boardingPlace,
      siblings: this.siblings,
    };
  
    // Convert undefined values to null
    Object.keys(map).forEach(key => {
      if (map[key] === undefined) {
        map[key] = null;
      }
    });
  
    return map;
  }

  static fromDataTable(row) {
    return new Student({
      admissionNo: utils.getFormattedAdmissionNo(row[2].toString()),
      name: utils.getFormattedTitle(row[1]),
      gender: Student._getGender(row[3]),
      dob: row[6] ? Student._getDate(row[6]) : null,
      contactNo: row[9]?.toString()??null,
      Class: Student._getClass(row[4]),
      sec: row[5],
      guardian: row[10],
      guardianRelation: row[11],
      guardianMobNo: row[13]?.toString()??null,
      guardianOccupation: row[12],
      fatherName: row[14],
      fatherMobNo: row[15]?.toString()??null,
      fatherOccupation: row[16],
      motherName: row[17],
      motherMobNo: row[19]?.toString()??null,
      motherOccupation: row[18],
      houseName: row[20],
      placeOfHouse: row[21],
      taluk: row[23],
      postOffice: row[22]?.toString()??null,
      pinCode: row[24]?.toString()??null,
      rationCard: row[25],
      physicallyChallenged: row[26] && ['yes', 'y'].includes(row[26].toString().toLowerCase()),
      previousSchool: row[27],
      aadhaarNo: row[8]?.toString()??null,
      nationality: row[28],
      caste: row[29],
      community: row[30],
      motherTongue: row[31],
      boardingPlace: row[32],
      siblings: [],
    });
  }

  static _getDate(dateString) {
    let dateParts;
    dateString = dateString.replace(/\s/g, ''); // Remove spaces

    if (dateString.includes('/')) {
      dateParts = dateString.split('/');
    } else {
      dateParts = dateString.split('-');
    }

    const day = parseInt(dateParts[0], 10);
    const month = utils.getMonthIndex(dateParts[1]);
    const year = parseInt(dateParts[2], 10);
    const date = new Date(year, month, day);
    return Timestamp.fromDate(date);
  }

  static _getGender(data) {
    if (data) {
      const gender = data.toString().toLowerCase();
      if (['male', 'm', 'boy'].includes(gender)) return 'M';
      if (['female', 'f', 'girl'].includes(gender)) return 'F';
    }
    return '';
  }

  static _getClass(_class) {
    if (!_class) return -3;
    if(utils.isRomanNumeral(_class)){
      return utils.convertRomanToInteger(_class);
    }
    const classStr = _class.toString().trim().toLowerCase().replace(/\s+/g, '');
    if (classStr.includes('ukg') || classStr.includes('fly3')) return 0;
    if (classStr.includes('lkg') || classStr.includes('fly2')) return -1;
    if (classStr.includes('prekg') || (classStr.includes('pre-kg')) || classStr.includes('fly1')) return -2;
    return parseInt(classStr, 10);
  }

  static _loadSiblings(data) {
    return data ? [...data] : [];
  }
}

